import { Icon } from '@material-ui/core';

import TooltipIconImage from 'Console/assets/images/icons/TooltipIcon.png';

interface TooltipIconProps {
    className: string | undefined;
}

const TooltipIcon = ({ className }: TooltipIconProps): JSX.Element => (
    <Icon className={className}>
        <img height={16} src={TooltipIconImage} />
    </Icon>
);

export default TooltipIcon;
